export const APROVADO = "APROVADO";
export const REPROVADO_POR_FREQUENCIA = "REPROVADO_POR_FREQUENCIA";
export const REPROVADO_POR_DESEMPENHO = "REPROVADO_POR_DESEMPENHO";

export const resultadoFinalText = (resultadoFinal) => {
  if (resultadoFinal === APROVADO) {
    return "Aprovado(a)";
  } else if (resultadoFinal === REPROVADO_POR_FREQUENCIA) {
    return "Reprovado(a) por Frequência";
  } else if (resultadoFinal === REPROVADO_POR_DESEMPENHO) {
    return "Reprovado(a) por Desempenho";
  } else {
    return "";
  }
};
